import { render } from "./DriveAsideMainMenu.vue?vue&type=template&id=43d5d562&scoped=true&ts=true"
import script from "./DriveAsideMainMenu.vue?vue&type=script&lang=ts"
export * from "./DriveAsideMainMenu.vue?vue&type=script&lang=ts"

import "./DriveAsideMainMenu.vue?vue&type=style&index=0&id=43d5d562&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d5d562"]])

export default __exports__